<template>
  <v-card class="skeleton-card elevation-1">
    <v-card-text class="pa-3">
      <v-layout row wrap align-center>
        <v-flex xs8>
          <div class="skeleton-title skeleton-shimmer"></div>
          <div class="skeleton-value skeleton-shimmer mt-2"></div>
        </v-flex>
        <v-flex xs4 class="text-xs-right">
          <div class="skeleton-icon skeleton-shimmer"></div>
        </v-flex>
      </v-layout>
      <div v-if="showSubtext" class="skeleton-subtext skeleton-shimmer mt-2"></div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'SkeletonCard',
  props: {
    showSubtext: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped>
.skeleton-card {
  background-color: #ffffff;
}

.skeleton-shimmer {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.skeleton-title {
  height: 14px;
  width: 60%;
}

.skeleton-value {
  height: 24px;
  width: 80%;
}

.skeleton-icon {
  height: 40px;
  width: 40px;
  border-radius: 50%;
  margin-left: auto;
}

.skeleton-subtext {
  height: 12px;
  width: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/common/SkeletonCard.vue